import React from 'react';
import { AutoComplete, AutoCompleteProps } from 'antd-v5';
import styled from 'styled-components';

const StringAutoComplete = (props: AutoCompleteProps<string>) => <AutoComplete<string> {...props} />;
export const SAutoComplete = styled(StringAutoComplete)`
  width: 100%;
  min-width: 450px;
  height: 40px;

  &.ant5-select-single .ant5-select-selector {
    height: 40px;
    border-radius: 20px;
    align-items: center;
  }
`;
